import gql from 'graphql-tag'

import { SaleOrderItemFragment } from '@/graphql/fragments/sales'

export const mutation = gql`
  ${SaleOrderItemFragment}
  mutation updateSaleOrderItem($id: Int!,$fields: sales_sale_order_item_set_input!) {
    record: update_sales_sale_order_item_by_pk(pk_columns: {id: $id}, _set: $fields){
      ...SaleOrderItem
    }
  }
`

export default mutation
